import SWRConfigWrapper from "@hornet-web-react/core/components/Utils/SWRConfigWrapper"
import { FC, PropsWithChildren, useCallback } from "react"
import { useSessionApi } from "@hornet-web-react/core/contexts/session"

type HornetSWRConfigWrapperProps = PropsWithChildren & {
  fallback?: object
}

const HornetSWRConfigWrapper: FC<HornetSWRConfigWrapperProps> = ({
  children,
  fallback = {},
}) => {
  const {
    user: { logout },
  } = useSessionApi()

  const onLogout = useCallback(() => {
    logout()

    // hard refresh to clean up any SWR cache etc
    window.location.href = "/"
  }, [logout])

  return (
    <SWRConfigWrapper onLogout={onLogout} fallback={fallback}>
      {children}
    </SWRConfigWrapper>
  )
}

export default HornetSWRConfigWrapper
